<template lang="pug">
  tbody
    tr
      th(colspan=2) {{ keno_title }}
      td.text-center {{ keno_upline_pt }}%
      td.text-center(v-show="isSearch") {{ keno_account_pt }}%
      td.text-center(v-show="isSearch") {{ keno_upline_remaining}}%
      td.text-center(v-show="isSearch") {{ keno_account_min }}%
</template>

<script>
export default {
  props: {
    isSearch: false,  },
  data() {
    return {
      keno_upline_min: 0,
      keno_upline_max: 0,
      keno_upline_pt: 0,
      keno_account_pt: 0,
      keno_upline_remaining: 0,
      keno_account_min: 0
    }
  },
  computed: {
    keno_title: function () {
      return this.$t("ui.keno") + " (" + this.keno_upline_min + "%-" + this.keno_upline_max + "%)"
    }
  }
}
</script>